import React from 'react';
interface GlobalFooterProps {
  onNavigate: (page: string) => void;
}
export function GlobalFooter({
  onNavigate
}: GlobalFooterProps) {
  return <footer className="bg-matte border-t border-white/5 py-16 md:py-20 px-6" data-id="element-44">
      <div className="max-w-7xl mx-auto" data-id="element-45">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8 mb-16" data-id="element-46">
          {/* Col 1: Brand */}
          <div data-id="element-47">
            <h2 className="font-serif text-[26px] text-gold tracking-ultra-wide mb-6" data-id="element-48">
              TEMPOO
            </h2>
            <p className="font-sans text-base text-white/40 leading-relaxed max-w-xs" data-id="element-49">
              9424 Annapolis Rd Suite B<br data-id="element-50" />
              Lanham, MD 20706
              <br data-id="element-51" />
              info@tempoolounge.com
            </p>
          </div>

          {/* Col 2: Navigate */}
          <div data-id="element-52">
            <h3 className="font-sans text-sm tracking-ultra-wide text-gold uppercase mb-6" data-id="element-53">
              Navigate
            </h3>
            <ul className="space-y-3" data-id="element-54">
              {['Home', 'Experience', 'Menu', 'Events', 'Gallery'].map(link => <li key={link} data-id="element-55">
                    <button onClick={() => {
                onNavigate(link.toLowerCase());
                window.scrollTo(0, 0);
              }} className="font-sans text-lg text-white/50 hover:text-gold transition-colors duration-300" data-id="element-56">
                      {link}
                    </button>
                  </li>)}
            </ul>
          </div>

          {/* Col 3: Legal */}
          <div data-id="element-57">
            <h3 className="font-sans text-sm tracking-ultra-wide text-gold uppercase mb-6" data-id="element-58">
              Legal
            </h3>
            <ul className="space-y-3" data-id="element-59">
              {['Privacy Policy', 'Terms of Service', 'Accessibility'].map(link => <li key={link} data-id="element-60">
                    <a href="#" className="font-sans text-base text-white/30 hover:text-white/60 transition-colors duration-300" data-id="element-61">
                      {link}
                    </a>
                  </li>)}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-62">
          <p className="font-sans text-base text-white/20" data-id="element-63">
            © 2024 Tempoo Restaurant & Lounge. All rights reserved.
          </p>
          <p className="font-sans text-base text-white/20" data-id="element-64">
            Designed by <span className="text-gold/50" data-id="element-65">Niishcloud</span>
          </p>
        </div>
      </div>
    </footer>;
}